import { useEffect } from 'react';

const setMeta = (name, content, attr = 'name') => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const upsertJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

const removeJsonLd = (id) => {
  const el = document.getElementById(id);
  if (el) el.remove();
};

const SEO = ({ title, description, path = '/', keywords, jsonLd, jsonLdId = 'page-jsonld' }) => {
  useEffect(() => {
    if (title) document.title = title;
    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:url', `https://finirio.com${path}`, 'property');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setCanonical(`https://finirio.com${path}`);
    if (jsonLd) upsertJsonLd(jsonLdId, jsonLd);
    return () => {
      if (jsonLd) removeJsonLd(jsonLdId);
    };
  }, [title, description, keywords, path, jsonLd, jsonLdId]);
  return null;
};

export default SEO;
